import React, { useContext } from 'react';

export const ProfileContext = React.createContext({});

export const useProfile = () => useContext(ProfileContext);
